import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import ErrorBoundary from 'src/frontend-common/components/MicroServiceErrorBundary';
import { useGetActiveCompanyName } from 'src/hooks/useGetActiveCompanyName';
import { useRuleEngine } from 'src/hooks/useRuleEngine';
import { CustomLoadingScreen } from 'src/pages/User';
import { selectUser } from 'src/redux/slices/userSlice';
import { isAdmin } from 'src/utils/user';

const RuleEngineWrapper: React.FC = () => {
  const activeCompany = useGetActiveCompanyName();
  const RuleEngine = useRuleEngine();
  const user = useSelector(selectUser);
  return (
    <ErrorBoundary>
      <Suspense fallback={<CustomLoadingScreen variant="circle" />}>
        <RuleEngine activeCompany={activeCompany} isAdmin={isAdmin(user)} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default RuleEngineWrapper;
